// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"e025c1ef","617":"ae494d2e"}[chunkId] + ".chunk.js";
};